import { createContext, PropsWithChildren, useEffect, useMemo } from 'react';
import { useToggle } from 'src/hooks';
import { useLocalStorage } from 'src/hooks/use-hooks-com';

type DarkmodeContextType = {
  readonly isDarkmode: boolean;
  readonly toggle: (mode?: boolean) => void;
};

export const DarkmodeContext = createContext<DarkmodeContextType>({
  isDarkmode: false,
  toggle: () => {},
});

export const DarkmodeProvider = ({ children }: PropsWithChildren<{}>) => {
  const [stored, saveLocalstorage] = useLocalStorage('dark-mode-enabled', true);
  const [isDark, toggleMode] = useToggle(stored);

  useEffect(() => {
    saveLocalstorage(isDark);
  }, [isDark, saveLocalstorage]);

  const value = useMemo(
    () => ({
      isDarkmode: isDark,
      toggle: toggleMode,
    }),
    [isDark, toggleMode]
  );

  return (
    <DarkmodeContext.Provider value={value}>
      {children}
    </DarkmodeContext.Provider>
  );
};
